import { apiSlice } from "@app/api/apiSlice"

export const moduleApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadAllModules: builder.query({
      query: (query) => {
        return {
          url: `role/module?${query ?? ""}`,
        }
      },
    }),
    loadOneModule: builder.mutation({
      query: (id) => ({
        url: `role/module/${id}`,
      }),
    }),
    loadCategoryDropdown: builder.query({
      query: () => "role/module-group?size=0",
    }),
    saveModule: builder.mutation({
      query: (body) => ({
        url: "role/module",
        method: "POST",
        body,
      }),
    }),
    loadAccessModule: builder.mutation({
      query: (id) => ({
        url: `role/access/module/${id}`,
      }),
    }),
    saveAccess: builder.mutation({
      query: (body) => ({
        url: `role/access/module/${body.id}`,
        method: "POST",
        body: { ...body.data },
      }),
    }),
    deleteModule: builder.mutation({
      query: (id) => ({
        url: `role/module-group/${id}`,
        method: "DELETE",
      }),
    }),
    importModule: builder.mutation({
      query: (file) => ({
        url: "role/module/import",
        method: "POST",
        body: { file },
      }),
    }),
  }),
  overrideExisting: true,
})

export const {
  useLoadAllModulesQuery,
  useLoadOneModuleMutation,
  useLoadCategoryDropdownQuery,
  useSaveModuleMutation,
  useLoadAccessModuleMutation,
  useSaveAccessMutation,
  useDeleteModuleMutation,
  useImportModuleMutation,
} = moduleApiSlice
